const initialState = null;

/**
 * WARNING! Organisation state is for now completly store into local storage!
 * Add additionnal information with caution
 */
export default function organisation() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (action.type === 'selectOrganisation') {
    return action.organisation;
  }
  if (action.type === 'removeOrganisation') {
    return null;
  }
  return state;
}